import styled from 'styled-components';
import { colors } from '@omilia/theme';
import { H1 } from '@omilia/typography';
import Button from '@omilia/button';

export const SH1 = styled(H1)`
  color: ${colors.COLOR_GREY_1000};
  padding-bottom: 24px;
  text-align: center;
`;

export const SButton = styled(Button)`
  margin-top: 12px;
`;
